import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';
import { FacebookPixel } from './components/FacebookPixel';
// Lazy-load everything below the fold so the hero paints fast.
// Each chunk loads in parallel as the user scrolls / when the browser is idle.
const SocialProofBar = lazy(() => import('./components/SocialProofBar').then(m => ({
  default: m.SocialProofBar
})));
const PainSection = lazy(() => import('./components/PainSection').then(m => ({
  default: m.PainSection
})));
const ProductIntro = lazy(() => import('./components/ProductIntro').then(m => ({
  default: m.ProductIntro
})));
const TomosGrid = lazy(() => import('./components/TomosGrid').then(m => ({
  default: m.TomosGrid
})));
const BonusGrid = lazy(() => import('./components/BonusGrid').then(m => ({
  default: m.BonusGrid
})));
const UrgencyBanner = lazy(() => import('./components/UrgencyBanner').then(m => ({
  default: m.UrgencyBanner
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const ComparisonTable = lazy(() => import('./components/ComparisonTable').then(m => ({
  default: m.ComparisonTable
})));
const TestimonialsFull = lazy(() => import('./components/TestimonialsFull').then(m => ({
  default: m.TestimonialsFull
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const PurchasePopup = lazy(() => import('./components/PurchasePopup').then(m => ({
  default: m.PurchasePopup
})));
const StickyBottomCTA = lazy(() => import('./components/StickyBottomCTA').then(m => ({
  default: m.StickyBottomCTA
})));
// Minimal fallback — keeps layout stable, prevents flashing
const SectionFallback = () => <div className="w-full" style={{
  minHeight: '200px'
}} data-id="element-0" />;
export function App() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="w-full min-h-screen bg-bg-primary text-white" data-id="element-1">
      <FacebookPixel data-id="element-2" />
      <Hero onCTAClick={scrollToPricing} data-id="element-3" />
      <Suspense fallback={<SectionFallback data-id="element-5" />} data-id="element-4">
        <SocialProofBar data-id="element-6" />
        <PainSection data-id="element-7" />
        <ProductIntro data-id="element-8" />
        <TomosGrid data-id="element-9" />
        <BonusGrid showFreeLabel={true} data-id="element-10" />
        <UrgencyBanner data-id="element-11" />
        <PricingSection onCTAClick={scrollToPricing} data-id="element-12" />
        <ComparisonTable data-id="element-13" />
        <TestimonialsFull data-id="element-14" />
        <Guarantee data-id="element-15" />
        <FAQ data-id="element-16" />
        <FinalCTA onCTAClick={scrollToPricing} data-id="element-17" />
        <Footer data-id="element-18" />
        <PurchasePopup data-id="element-19" />
        <StickyBottomCTA onCTAClick={scrollToPricing} data-id="element-20" />
      </Suspense>
    </div>;
}